import React, { useContext, useState, useEffect } from 'react';
import { AppContext } from '../../contexts/AppContext';
import { Box, Link, Spinner } from '@amzn/awsui-components-core';
import {
  ContentSubType,
  ContentType,
  Publication,
  UserType,
} from '@amzn/awscat-pattern-library-service-model';
import { isAllowedToEditPost, userTypeToAudienceMap } from '../../api/ContentUtil';
import RouterPaths from '../../common/RouterPaths';
import arraySort from 'array-sort';

interface Props {
  allPosts: Publication[];
  loading?: boolean;
}

const LatestUpdateBar = (props: Props) => {
  const { allPosts, loading } = props;
  const appContext = useContext(AppContext);
  // @ts-expect-error TS2339 - strict migration
  const { userProfile } = appContext?.authnInfo;
  const [latestGettingStartedPost, setLatestGettingStartedPost] = useState<Publication | null>(
    null,
  );
  const [latestReleasedNote, setLatestReleaseNote] = useState<Publication | null>(null);

  useEffect(() => {
    const posts = allPosts.filter(
      (p) =>
        isAllowedToEditPost(userProfile) ||
        userTypeToAudienceMap.get(userProfile.type as UserType)?.includes(p.contentAudience),
    );
    arraySort(posts, 'lastUpdated', { reverse: true });
    setLatestGettingStartedPost(
      // @ts-expect-error TS2345 - strict migration
      posts.filter(
        (post) => post?.contentTypeMetadata?.contentSubType === ContentSubType.GettingStarted,
      )?.[0],
    );
    setLatestReleaseNote(
      // @ts-expect-error TS2345 - strict migration
      posts.filter(
        (post) => post?.contentTypeMetadata?.contentSubType === ContentSubType.ReleaseNotes,
      )?.[0],
    );
  }, [loading, allPosts, userProfile]);

  const renderLatestGettingStartedPost = () => {
    if (!latestGettingStartedPost) {
      return null;
    }
    return (
      <>
        <Link variant="secondary" href={`/post-viewer/${latestGettingStartedPost.contentId}`}>
          <span className="latest-update-text">
            {latestGettingStartedPost?.contentMetadata?.contentName}
          </span>
        </Link>
        <div className="pipe-white">|</div>
      </>
    );
  };

  const renderLatestReleaseNote = () => {
    if (!latestReleasedNote) {
      return null;
    }
    return (
      <>
        <Link variant="secondary" href={`/post-viewer/${latestReleasedNote.contentId}`}>
          <span className="latest-update-text">
            {latestReleasedNote?.contentMetadata?.contentName}
          </span>
        </Link>
        <div className="pipe-white">|</div>
      </>
    );
  };

  const renderLatestUpdates = () => {
    if (loading) {
      return <Spinner variant="inverted" />;
    }
    return (
      <>
        {renderLatestGettingStartedPost()}
        {renderLatestReleaseNote()}
        <Link variant="secondary" href={RouterPaths.WHATS_NEW}>
          <span className="latest-update-text">View all updates</span>
        </Link>
      </>
    );
  };

  return (
    <div className="latest-update">
      <Box className="latest-update-desc">
        <span className="latest-update-title">Latest updates:</span>
      </Box>
      {renderLatestUpdates()}
    </div>
  );
};

export default LatestUpdateBar;
